import { Components, Theme } from '@mui/material/styles';

export const iconTheme: Components<Theme>['MuiIcon'] = {
  // styleOverrides: {},
  // variants: [],
};
